import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import * as componentAction from '../store/component.action';
import { checkArray } from '../../../Components/helper';
import Loader from '../../../Components/Utility/Loader/Loader';
import { useComponentOrderState } from '../ComponentProvider';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import PurchaseOrderDocuments from './PurchaseOrderDetail/AllRenderTable/PurchaseOrderDocument';
import ComponentMail from './PurchaseOrderDetail/AllRenderTable/ComponentMail';
import { DuplicateIcon, EditIcon, DownloadIcon, FileIcon, DeleteIcon, PublishIcon, PreviewIcon } from '../../../bombiix-icon';

function OrderTable() {
  const dispatch = useDispatch();
  const listInnerRef = useRef();
  const { t } = useTranslation('common');
  const params = useParams();
  const reducerState = useSelector((redState) => redState);
  const {
    ComponentOrderReducer: { createdByUser },
  } = reducerState;
  const { Componentstate, setComponentState, onSortPOColumn } = useComponentOrderState();
  const { PurchaseOrderData, isPageLoader } = Componentstate;
  const [state, setState] = useState({
    emailModal: false,
    bcc: '',
    cc: '',
    to: '',
    message: '',
    toErr: false,
    bccErr: false,
    ccErr: false,
    id: null,
    userList: [],
  });
  const { bcc, cc, to, message } = state;

  useEffect(() => {
    if (createdByUser) {
      const userList1 = createdByUser?.map((val) => {
        return {
          id: val.email,
          name: `${val.firstName} ${val.lastName}`,
          display: `${val.email}, `,
          label: val.email,
        };
      });
      setState((prev) => ({
        ...prev,
        userList: userList1,
      }));
    }
  }, [createdByUser]);

  const supplierType = params?.supplierType;
  const handlePOPageNextInScroll = async () => {
    let pageIndex = Componentstate?.pageIndex;
    pageIndex += 1;
    setComponentState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      isPageLoader: true,
    }));
    const reqObj = {
      pageIndex,
      pageSize: Componentstate?.pageSize,
      isScrolled: true,
    };
    if (Componentstate?.searchText) {
      reqObj.searchText = Componentstate.searchText;
    }

    if (Componentstate?.sortOrder) {
      reqObj.sortOrder = Componentstate?.sortOrder;
      reqObj.sortPropertyName = Componentstate?.sortPropertyName;
    }

    const res = await dispatch(componentAction.fetchPurchaseOrder(reqObj));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        isPageLoader: false,
      }));
    }
  };

  const handleDeletePO = (id) => {
    setComponentState((prevState) => ({
      ...prevState,
      deletedId: id,
      deleteModal: true,
    }));
  };
  const handleCloseDeleteModal = () => {
    setComponentState((prevState) => ({
      ...prevState,
      deletedId: null,
      deleteModal: false,
    }));
  };

  const handleSelectChange = (value, field) => {
    if (field === 'to') {
      setState((prev) => ({
        ...prev,
        toErr: false,
      }));
    }
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const confirmDelete = async () => {
    const response = await dispatch(componentAction.deletePurchaseOrder(Componentstate?.deletedId, t));
    const reqObj = {
      pageIndex: 1,
      pageSize: Componentstate?.pageSize,
    };
    if (Componentstate?.searchText) {
      reqObj.searchText = Componentstate?.searchText;
    }

    if (Componentstate?.sortOrder) {
      reqObj.sortOrder = Componentstate?.sortOrde;
      reqObj.sortPropertyName = Componentstate?.sortPropertyName;
    }
    if (response) {
      await dispatch(componentAction.clearReducer());
      setComponentState((prevState) => ({
        ...prevState,
        PurchaseOrderData: [],
        pageIndex: 1,
      }));
      await dispatch(componentAction.fetchPurchaseOrder(reqObj));
      handleCloseDeleteModal();
    }
  };

  const forAscandDesc = () => {
    return Componentstate?.sortOrder === 'Asc' ? <i className="fa fa fa-sort-up ml-1" /> : <i className="fa fa fa-sort-desc ml-1" />;
  };

  const iconsChange = () => {
    return Componentstate?.sortOrder === '' ? <i className="fa fa fa-sort ml-1" /> : forAscandDesc();
  };

  const downloadDocument = async (id) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const req = {
      timeZone,
    };
    await dispatch(componentAction.downloadPdf(id, req, t));
  };

  const sentEmailToSupplier = async (ele) => {
    setState((prev) => ({
      ...prev,
      emailModal: true,
      id: ele?._id,
      to: ele?.supplierEmail,
    }));

    await dispatch(
      componentAction.getCreatedByUser({
        CompanyUsers: true,
        supplierId: ele?.supplierId,
      }),
    );
  };

  const handleFiles = async (ele) => {
    setComponentState((poState) => ({
      ...poState,
      openPOFiles: true,
      poFileData: ele,
    }));
    await dispatch(componentAction.fetchPurchaseOrderDocument(ele._id));
  };
  const toggleFiles = () => {
    setComponentState((poStateEnd) => ({
      ...poStateEnd,
      openPOFiles: false,
      poFileData: null,
    }));
  };

  const toggleEmailModal = () => {
    setState((prev) => ({
      ...prev,
      emailModal: false,
      bcc: '',
      cc: '',
      to: '',
      message: '',
      toErr: false,
      bccErr: false,
      ccErr: false,
      id: null,
      invalidErr: false,
    }));
  };
  const mailCheck = (array) => {
    return array.length <= 0;
  };
  function validateEmail(email) {
    const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
    return re.test(String(email).toLowerCase());
  }
  const submitValidation = () => {
    let ccMailErr = false;
    let showToVaildErr = false;
    let bccMailErr = false;
    let mailArray = to ? to.split(',') : [];
    let ccMailarray = cc ? cc.split(',') : [];
    let bccMailarray = bcc ? bcc.split(',') : [];
    mailArray = mailArray.filter((val) => val !== '' && val !== ' ');

    ccMailarray = ccMailarray.filter((val) => val !== '' && val !== ' ');
    bccMailarray = bccMailarray.filter((val) => val !== '' && val !== ' ');
    showToVaildErr = mailCheck(mailArray);
    mailArray = mailArray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        showToVaildErr = true;
      }
      return val;
    });
    ccMailarray = ccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        ccMailErr = true;
      }
      return val;
    });
    bccMailarray = bccMailarray.map((val) => {
      val = val.trim();
      if (!validateEmail(val)) {
        bccMailErr = true;
      }
      return val;
    });

    setState((prev) => ({
      ...prev,
      toErr: showToVaildErr,
      ccErr: ccMailErr,
      bccErr: bccMailErr,
    }));
    if (!showToVaildErr && !ccMailErr && !bccMailErr) {
      return {
        mailArray,
        ccMailarray,
        bccMailarray,
      };
    }
    return false;
  };

  const sendEmailToSupplier = async () => {
    const submitObj = submitValidation();
    if (submitObj) {
      setState((prev) => ({
        ...prev,
        loader: true,
      }));
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

      const reqObj = {
        to: submitObj.mailArray,
        bcc: submitObj.bccMailarray,
        cc: submitObj.ccMailarray,
        message,
        timeZone,
      };
      const res = await dispatch(componentAction.SentEmailPurchaseOrder(state?.id, reqObj, t));
      if (res.code === 200) {
        setState((prev) => ({
          ...prev,
          cc: '',
          bcc: '',
          message: '',
          emailModal: false,
          id: null,
        }));
      }
      setState((prev) => ({
        ...prev,
        loader: false,
      }));
    }
  };

  return (
    <Container fluid className="pt-4 h-100">
      <div
        id="scrollableDiv_PIM"
        style={{
          height: 'calc(100vh - 140px)',
          overflow: 'auto',
        }}
        ref={listInnerRef}
      >
        <InfiniteScroll
          dataLength={PurchaseOrderData?.length}
          loader={isPageLoader && <Loader />}
          hasMore={Componentstate?.hasMore}
          next={handlePOPageNextInScroll}
          scrollableTarget="scrollableDiv_PIM"
          className="fixed-col-container"
        >
          <table className="table fixed-col-table custom-table m-0 layout-fixed">
            <thead>
              <th
                onClick={() => {
                  onSortPOColumn('purchaseOrderNo');
                }}
                className="w-140px"
              >
                {t('ADD_PO_TEMPLATE_PROVIDER.PERCHASE_ORDER')}
                {Componentstate?.sortPropertyName === 'purchaseOrderNo' ? <>{iconsChange()}</> : <i className="fa fa fa-sort ml-1" />}
              </th>
              <th>{t('PURCHASE_ORDER_NUMBER.PURCHASE_DATE')}</th>
              <th
                onClick={() => {
                  onSortPOColumn('supplierName');
                }}
              >
                {t('COSTING.SUPPLIER')}
                {Componentstate?.sortPropertyName === 'supplierName' ? <>{iconsChange()}</> : <i className="fa fa fa-sort ml-1" />}
              </th>
              <th
                onClick={() => {
                  onSortPOColumn('supplierType');
                }}
                className="w-140px"
              >
                {t('PURCHASE_ORDER_NUMBER.PURCHASE_COMPONENT')}
                {Componentstate?.sortPropertyName === 'supplierType' ? <>{iconsChange()}</> : <i className="fa fa fa-sort ml-1" />}
              </th>
              <th
                onClick={() => {
                  onSortPOColumn('currentStatus');
                }}
              >
                {t('PURCHASE_ORDER_NUMBER.CURRENT_STATUS')}
                {Componentstate?.currentStatus === 'currentStatus' ? <>{iconsChange()}</> : <i className="fa fa fa-sort ml-1" />}
              </th>
              <th>{t('PURCHASE_ORDER_NUMBER.ACTION_DATE_TIME')}</th>
              <th
                onClick={() => {
                  onSortPOColumn('previousStatus');
                }}
              >
                {t('PURCHASE_ORDER_NUMBER.PREVIOUS_STATE')}
                {Componentstate?.currentStatus === 'previousStatus' ? <>{iconsChange()}</> : <i className="fa fa fa-sort ml-1" />}
              </th>
              <th>{t('PURCHASE_ORDER_NUMBER.DATE_TIME')}</th>
              <th className="w-150px">{t('ADD_PO_TEMPLATE_PROVIDER.ACTIONS')}</th>
            </thead>
            <tbody>
              {checkArray(PurchaseOrderData) ? (
                PurchaseOrderData.map((ele) => {
                  const purchaseOrderNo = ele?.purchaseOrderNo || 'NA';
                  return (
                    <tr key={ele?._id}>
                      <td>
                        {supplierType ? (
                          <Link
                            className="cursor-pointer text-dark text-decoration-none"
                            to={`/sub-supplier/purchase-order/${supplierType}/${ele?._id}/${supplierType}`}
                          >
                            {purchaseOrderNo}
                            <button className="btn-tbl-action" aria-label="Edit" type="button" title="Edit">
                              <PreviewIcon size={24} />
                            </button>
                          </Link>
                        ) : (
                          purchaseOrderNo
                        )}
                      </td>

                      <td>{moment(ele?.poSelectedDate).format('DD-MMMM-YYYY')}</td>
                      <td>{ele?.supplierName ? ele?.supplierName : 'NA'}</td>
                      <td>{ele?.supplierType}</td>
                      <td>{ele?.currentStatus}</td>
                      <td>{moment(ele?.actionDate).format('DD-MMMM-YYYY, h:mm a')}</td>

                      <td> {ele?.previousStatus ? ele.previousStatus : ''}</td>
                      <td>{moment(ele?.previousDate).isValid() ? moment(ele?.previousDate).format('DD-MMMM-YYYY, h:mm a') : ''}</td>
                      <td>
                        {!supplierType && (
                          <>
                            <Link
                              title={t('ADD_PO_TEMPLATE_PROVIDER.DUPLICATE')}
                              className="cursor-pointer text-dark text-decoration-none btn-tbl-action"
                              to={`/component-order/purchase-order/${ele?._id}/?forDuplication=true`}
                            >
                              <DuplicateIcon size={24} />
                            </Link>

                            <Link
                              title={t('ADD_PO_TEMPLATE_PROVIDER.EDITS')}
                              className="cursor-pointer text-dark text-decoration-none btn-tbl-action"
                              to={`/component-order/purchase-order/${ele?._id}`}
                            >
                              <EditIcon size={24} />
                            </Link>
                            {!['Cancelled', 'Canceled', 'Approved', 'Delivered'].includes(ele?.currentStatus) && (
                              <button
                                className="btn-tbl-action"
                                title={t('SETUP_2FA.SUBMIT')}
                                aria-label="save"
                                onClick={() => {
                                  sentEmailToSupplier(ele);
                                }}
                                type="button"
                              >
                                <PublishIcon size={24} />
                              </button>
                            )}
                          </>
                        )}

                        {!['Cancelled', 'Canceled'].includes(ele?.currentStatus) && (
                          <button
                            className="btn-tbl-action"
                            title={t('PURCHASE_ORDER_NUMBER.DOWNLOADING')}
                            onClick={() => downloadDocument(ele?._id)}
                            type="button"
                            aria-label="download"
                          >
                            <DownloadIcon size={24} />
                          </button>
                        )}
                        {!supplierType && (
                          <button
                            className="btn-tbl-action"
                            aria-label="download"
                            title={t('PURCHASE_ORDER_NUMBER.FILES')}
                            type="button"
                            onClick={() => handleFiles(ele)}
                          >
                            <FileIcon size={24} />
                          </button>
                        )}
                        {!supplierType && !['Cancelled', 'Canceled'].includes(ele?.currentStatus) && (
                          <button
                            className="btn-tbl-action"
                            aria-label="delete"
                            title={t('SPEC_TEMP_LIBRARY.DELETE')}
                            onClick={() => {
                              handleDeletePO(ele._id);
                            }}
                            type="button"
                          >
                            <DeleteIcon size={24} />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={9}>
                    <span className="align-items-center justify-content-center d-flex">{t('ADD_PO_TEMPLATE_PROVIDER.TEMPLATE_NOT_FOUND')}</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
        {Componentstate.openPOFiles && <PurchaseOrderDocuments onOpen={Componentstate.openPOFiles} toggle={toggleFiles} data={Componentstate.poFileData} />}
        {Componentstate?.deleteModal && (
          <ConfirmationPopup
            onOpen={Componentstate?.deleteModal}
            onConfirm={() => confirmDelete()}
            title={t('PURCHASE_ORDER_NUMBER.DELETE_MESSAGES')}
            message={t('PURCHASE_ORDER_NUMBER.SELECTED_PURCHASE_ORDER')}
            toggle={() => handleCloseDeleteModal()}
          />
        )}
        {state?.emailModal && (
          <ComponentMail mainState={state} toggle={toggleEmailModal} handleOnChange={handleSelectChange} sendEmailToSupplier={sendEmailToSupplier} />
        )}
      </div>
    </Container>
  );
}

export default OrderTable;
